import makeStyles from '@material-ui/core/styles/makeStyles';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import IcInfo from '../../assets/images/svg/ic_info_blue.svg';

const useStyles = makeStyles(
  () => ({
    tip: {
      display: 'flex',
      alignItems: 'start',
      padding: '13px 16px',
      background: 'rgba(33, 181, 205, 0.1)',
      borderRadius: 4,
      '& > img': {
        marginRight: 12,
      },
      '& > div': {
        fontWeight: '400',
        fontSize: '15px',
        lineHeight: '21px',
        color: '#177484',
      },
    },
  }),
  {
    name: 'Tip',
  },
);

function Tip({ title, text, className }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classnames(classes.tip, className)}>
      <img src={IcInfo} alt="alert" />
      <div>
        <div style={{ fontWeight: '500' }}>{title || t('tip')}</div>
        {text}
      </div>
    </div>
  );
}

export default Tip;
